/**
 * Studio product grid: switches between collection tabs ("Best Sellers / New In").
 */
class EmeProductGrid extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = (event) => {
    const tab = /** @type {HTMLElement | null} */ (/** @type {HTMLElement} */ (event.target).closest('[data-tab]'));
    if (!tab) return;

    const id = tab.dataset.tab;
    for (const button of this.querySelectorAll('[data-tab]')) {
      button.setAttribute('aria-pressed', String(/** @type {HTMLElement} */ (button).dataset.tab === id));
    }
    for (const panel of this.querySelectorAll('[data-panel]')) {
      /** @type {HTMLElement} */ (panel).hidden = /** @type {HTMLElement} */ (panel).dataset.panel !== id;
    }
    for (const link of this.querySelectorAll('[data-panel-link]')) {
      /** @type {HTMLElement} */ (link).hidden = /** @type {HTMLElement} */ (link).dataset.panelLink !== id;
    }
  };
}

if (!customElements.get('eme-product-grid')) {
  customElements.define('eme-product-grid', EmeProductGrid);
}
